<div class="footer">
  <div class="copyright">© Copyright 2025 Vanhu Tech</div>
  <div class="footer-links">
    <div [routerLink]="['/privacy-policy']">Privacy Policy</div>
    <div><a href="mailto:info@vanhutech.org">Contact Us</a></div>
  </div>
</div>
